import "./BannerInDriveStyles.scss";

export default function BannerInDrive() {
    return (
        <div className="banner_indrive" role="img" aria-label="wcar e inDrive: bonos exclusivos, hasta el 100% de financiación">
            <div className="banner_indrive_pattern" style={{ backgroundImage: "url(/assets/indrive/pattern.png)" }} />
            <div className="banner_indrive_brands">
                <img src="/assets/indrive/wcar-logo.svg" alt="" className="banner_indrive_wcar" />
                <span className="banner_indrive_divider" />
                <span className="banner_indrive_logo">
                    <img src="/assets/indrive/indrive-logo.png" alt="" />
                    <span className="banner_indrive_logo_ring" />
                </span>
            </div>
            <div className="banner_indrive_text">
                <h2>
                    OBTÉN <mark>BONOS EXCLUSIVOS</mark>
                </h2>
                <p>
                    Hasta el <strong>100%</strong> de financiación
                </p>
            </div>
            <div className="banner_indrive_visual" aria-hidden>
                <img src="/assets/indrive/banner-shape.svg" alt="" className="banner_indrive_shape" />
                <span className="banner_indrive_car">
                    <img src="/assets/indrive/banner-car.png" alt="" />
                </span>
            </div>
        </div>
    );
}
